import { ComponentType } from "react";
import Credentials from "view/SignUp/SignUpToken/components/Credentials";
import StandDetails from "view/SignUp/SignUpToken/components/StandDetails";
import SuccessPage from "view/SignUp/SignUpToken/components/SuccessPage";

const stepToComponent: Record<number, ComponentType> = {
  0: Credentials,
  1: StandDetails,
  2: SuccessPage,
};
export default stepToComponent;
